import { render, staticRenderFns } from "./DewormingSecondPage.vue?vue&type=template&id=2b675db2&scoped=true&"
import script from "./DewormingSecondPage.vue?vue&type=script&lang=js&"
export * from "./DewormingSecondPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b675db2",
  null
  
)

export default component.exports